// Single source of truth for the app version
// Update this when releasing a new version (e.g. "v26")
export const APP_VERSION = "v33";
